import { faMinusCircle, faPlusCircle } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import HtmlTrans from 'components/shared/HtmlTrans';
import { useI18n } from 'hooks/useI18n';
import { useRouter } from 'next/router';
import { useEffect, useRef, useState } from 'react';
import { getPublicPath } from 'utils/paths';
import { INTRODATA } from './Intro.constants';
import {
  StyledContainer,
  StyledData,
  StyledDataContent,
  StyledDataItem,
  StyledDataList,
  StyledDataTitle,
  StyledDataValue,
  StyledHero,
  StyledHeroImage,
  StyledHeroTitle,
  StyledIntro,
  StyledIntroText,
  StyledIntroTitle,
  StyledReadMoreButton
} from './Intro.styled';

type IntroProps = {
  manfreditesCount: number;
};

const Intro: React.FC<IntroProps> = ({ manfreditesCount }) => {
  const { t } = useI18n('developer-career-report-2025');
  const { locale } = useRouter();

  const introData = INTRODATA(t, locale, manfreditesCount);

  const [displayReadMore, setdisplayReadMore] = useState(false);

  const clampableText = useRef<HTMLDivElement>(null);

  function checkLineClamp(): void {
    if (
      clampableText.current &&
      clampableText.current.clientHeight < clampableText.current.scrollHeight
    ) {
      setdisplayReadMore(true);
    } else {
      setdisplayReadMore(false);
    }
  }

  useEffect(() => {
    checkLineClamp();
  }, []);

  const [showAllText, setShowAllText] = useState(false);

  return (
    <StyledContainer>
      <StyledHero>
        <StyledHeroTitle>
          <span className="pretitle">{t('mantechcar25.hero.pre-title')}</span>
          <span>
            {t('mantechcar25.hero.title')} <span className="year">2025</span>
          </span>
        </StyledHeroTitle>
        <StyledHeroImage
          src={getPublicPath('/images/stateSector/2025/hero.png')}
          alt=""
        />
      </StyledHero>
      <StyledIntro>
        <StyledIntroTitle>
          <HtmlTrans
            ns="developer-career-report-2025"
            i18nKey="mantechcar25.hero.intro-title"
          />
        </StyledIntroTitle>
        <StyledIntroText
          ref={clampableText}
          className={`${showAllText ? 'display-full-text' : ''}`}
        >
          <HtmlTrans
            ns="developer-career-report-2025"
            i18nKey="mantechcar25.hero.intro"
          />
        </StyledIntroText>
        {displayReadMore && (
          <StyledReadMoreButton
            type="button"
            onClick={(): void => setShowAllText(!showAllText)}
          >
            <FontAwesomeIcon
              icon={!showAllText ? faPlusCircle : faMinusCircle}
            />
            {!showAllText && <span>{t('mantechcar25.hero.read-more')}</span>}
            {showAllText && <span>{t('mantechcar25.hero.read-less')}</span>}
          </StyledReadMoreButton>
        )}
      </StyledIntro>

      <StyledData>
        <StyledDataTitle>{t('mantechcar25.data.title')}</StyledDataTitle>
        <StyledDataList>
          {introData.map((item, index) => (
            <StyledDataItem key={index}>
              <StyledDataValue>{item.value}</StyledDataValue>
              <StyledDataContent>{item.text}</StyledDataContent>
            </StyledDataItem>
          ))}
        </StyledDataList>
      </StyledData>
    </StyledContainer>
  );
};

export default Intro;
